
import { sponsorsData } from '../../../mocks/sponsors';

export default function Sponsors() {
  return (
    <section id="sponsors" className="py-32 px-6 bg-gray-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-5xl md:text-6xl font-light mb-6 tracking-tight" style={{ fontFamily: "'Playfair Display', serif" }}>
            Partners
          </h2>
          <p className="text-lg text-gray-600">
            Supporting Caribbean design excellence
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-12 items-center">
          {sponsorsData.map((sponsor, index) => (
            <div key={index} className="flex items-center justify-center p-6 bg-white hover:shadow-lg transition-shadow cursor-pointer">
              <div className="text-center">
                <div className="text-2xl font-light text-gray-400 mb-2">{sponsor.name}</div>
                <p className="text-xs text-gray-500 tracking-wide">{sponsor.category}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-16">
          <p className="text-gray-600 mb-6">Interested in partnering with us?</p>
          <button 
            onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
            className="px-8 py-3 border border-black text-black text-sm tracking-widest hover:bg-black hover:text-white transition-all cursor-pointer whitespace-nowrap"
          >
            BECOME A PARTNER
          </button>
        </div>
      </div>
    </section>
  );
}
